import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { clientConstants } from '..';

export const useForceAttachClient = (props: { houseId?: number | null }) => {
  const isPermission = useAppSelector(state => state?.userReducer?.isPermissions);

  return useQuery<boolean>({
    queryKey: [clientConstants.queryKeys.FORCE_ATTACH_CLIENT, props],
    queryFn: async () => {
      const res = await $api.get(
        stringifyUrl({
          url: '/v1/force-attach-client',
          query: {
            houseId: props?.houseId
          }
        })
      );

      return res?.data?.data;
    },
    enabled: !!props?.houseId && isPermission?.PERMISSION_PAGE_CRM
  });
};
